import { inject, Injectable } from '@angular/core';
import { EventSystemDetailed } from './models/event-systems/event-system-detailed.model';
import { Observable } from 'rxjs';
import { ApiWrapperService } from 'ngx-apiwrapper';

@Injectable({
  providedIn: 'root'
})
export class EventSystemsService {
  private readonly _apiWrapper = inject(ApiWrapperService);

  getEventSystems(): Observable<EventSystemDetailed[]>{
    return this._apiWrapper.get<EventSystemDetailed[]>('event-systems/list?detailed=true')
  }

  getEventSystem(name:string): Observable<EventSystemDetailed> {
    return this._apiWrapper.get<EventSystemDetailed>(`event-systems/${name}`)
  }
}
